<script setup>
import {cloneDeep} from "lodash"
import DatePicker from "vue2-datepicker";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";
import RawData from "@/components/widgets/raw-data.vue";
import Multiselect from "vue-multiselect";
export default {
    name: 'SupplierOfferModal',
    props: {
        offers: Array,
        modalTitle: String,
        units: Array,
        selectedSupplierId: Number
    },
    components: {
        DatePicker,
        MaskedInput,
        RawData,
        Multiselect
    },
    data(){
        return {
            search: null,
            perPage: 5,
            pageOptions: [5, 10, 25, 50, 100],
            currentPage: 1,
            returnDate: null,
            submitted: false,
            currencyMask: createNumberMask({
                prefix: "",
                includeThousandsSeparator: true,
                allowDecimal: true,
            }),
            dayMask: createNumberMask({
                prefix: "",
                includeThousandsSeparator: false,
                allowDecimal: false,
            }),
        }
    },
    computed: {
        filtered(){
            let data = this.offers;
            var total = this.currentPage * this.perPage;
            if(this.search && this.search.trim() != ""){
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.search.toUpperCase());
                });
            }
            var currentData = data.slice(total - this.perPage, total);
            if (this.currentPage > 1 && currentData.length == 0) {
                total = (this.currentPage - 1) * this.perPage;
                currentData = data.slice(total - this.perPage, total);
            }
            return currentData;
        },
        rows(){
            let data = this.offers;
            if(this.search && this.search.trim() != ""){
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.search.toUpperCase());
                });
            }
            return data.length;
        },
    },
    methods: {
        async stretchInput(returnDate){
            this.returnDate = new Date(returnDate);
            await this.wait(100);
            this.offers.forEach((item) => {
                if (item.offer.deliveryPeriod && !item.offer.noOffer) {
                    this.autoWidth(item.offer.deliveryPeriod, item.offer.rfqItemId);
                }
                let element = this.$refs[`itemDescription${item.offer.rfqItemId}`];
                if(element && element.length > 0) {
                    this.autoGrowTemplate(element[0], 15);
                }
            });
        },
        autoGrowTemplate(element, size){
            element.style.height = `${size}px`;
            element.style.height = `${element.scrollHeight}px`;
        },
        autoGrow(element, size) {
            element.target.style.height = `${size}px`;
            element.target.style.height = `${element.target.scrollHeight}px`;
        },
        autoWidth(element, id) {
            let width = element ? element.length : 23;
            if(this.$refs[`ref-offer-${id}`]){
                let ref = this.$refs[`ref-offer-${id}`][0];
                ref.$el.style.width = `${width}ch`;
            }
        },
        async saveReturnDate() {
            let returnBool = false;
            await this.$store
                .dispatch("rfqsupplier/UpdateReturnedDate", {
                    id: this.selectedSupplierId,
                    rfqDate: this.getDate(this.returnDate),
                })
                .then((res) => {
                    if(res.data.error){
                        return returnBool;
                    }
                    this.$emit('updateReturnDate', this.getDate(this.returnDate))
                    returnBool = true;
                })
                .catch((err) => returnBool = true);
            return returnBool;
        },
        async saveOffers() {
            await this.saveReturnDate();
            var count = 0;
            var errors = 0;
            var data = [];
            this.offers.forEach((item) => {
                if(parseFloat(item.offer.quantity) > 0 && parseFloat(item.offer.unitCost) > 0 && !item.offer.noOffer){
                    if((!item.offer.itemName.trim() || item.offer.itemName.trim().length < 3)){
                        errors++;
                        item.errorItemName = true;
                    }
                    if(!item.offer.description.trim()){
                        errors++;
                        item.errorDescription = true;
                    }
                    if(!item.offer.deliveryPeriod.trim()){
                        errors++;
                        item.errorDelivery = true;
                    }
                }
                if ((!item.offer.itemName.trim() || !parseFloat(item.offer.quantity) || !parseFloat(item.offer.unitCost)) && !item.offer.noOffer) {
                    count++;
                } else {
                    item.offer.unitId = item.offer.unit.id;
                    item.offer.index = this.offers.indexOf(item);
                    item.offer.totalAmt = parseFloat(this.getExactAmt(item.offer.quantity)) * parseFloat(this.getExactAmt(item.offer.unitCost));
                    data.push(item.offer);
                }
            });
            if(errors > 0){
                this.showToast(`You have ${errors} errors. Please check the inputs`, "warning");
                return this.submitted = true;
            }
            if (count == this.offers.length) {
                return this.showToast("Cannot save empty offer", "warning");
            }
            this.$emit('saveOfferMethod', data)
        },
        getTotalByRow(z) {
            let qty = z.quantity ? this.getExactAmt(z.quantity) : 0;
            let unitCost = z.unitCost ? this.getExactAmt(z.unitCost) : 0;
            return parseFloat(qty) * parseFloat(unitCost);
        },
        async noSupplierOffer(offer){
            let noOffer = !offer.noOffer;
            let data = { id: offer.id, status: noOffer}
            let done = 0;
            if(offer.id == 0){
                offer.unitId = offer.unit.id;
                offer.unitCost = offer.unitCost ? offer.unitCost : 0;
                await this.$store.dispatch("rfqsupplieroffer/CreateRSO", offer)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        data.id = res.data.id;
                        offer.id = res.data.id;
                    })
                    .catch((err) => {
                        return this.showToast("RFQ Item went wrong!", "error");
                    });
            }
            await this.$store
                .dispatch("rfqsupplieroffer/ChangeOfferStatus", data)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    done++;
                })
            if(done > 0){
                this.showToast("Successfully updated status", "success");
            }else{
                this.showToast("Something went wrong!", "error");
            }
        },
        addAttachment(){
            this.$emit('addAttachment')
        }
    }
}
</script>
<template>
    <b-modal
        id="offer-modal"
        :title="modalTitle"
        size="xl"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
    >
        <div class="d-flex justify-content-between mb-2">
            <div>
                <label for="" class="mb-0 me-2 text-nowrap">Search Item:</label>
                <div class="d-flex">
                    <input type="text" class="form-control w-250px" placeholder="Search Item..." v-model="search">
                    <b-form-select
                        class="form-select ms-1 w-25"
                        v-model="perPage"
                        :options="pageOptions"
                    ></b-form-select>
                </div>
            </div>
            <div>
                <label for="" class="mb-0 me-2 text-nowrap">Date Returned:</label>
                <date-picker
                    v-model="returnDate"
                    :first-day-of-week="1"
                    lang="en"
                    placeholder="Enter Date Returned..."
                    input-class="form-control text-green font-weight-bold"
                ></date-picker>
            </div>
        </div>
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th>
                        Item Name
                        <div>
                            <small>Item Description</small>
                        </div>
                    </th>
                    <th style="width: 120px">Unit</th>
                    <th style="width: 150px">Qty</th>
                    <th style="width: 150px">Unit Cost</th>
                    <th style="width: 150px">Total</th>
                </tr>
            </thead>
            <tbody>
                <template v-for="offer in filtered">
                    <tr :key="offer.id">
                        <td class="position-relative">
                            <RawData 
                                :data="offer" 
                                v-if="$store.state.decrypt.isAdmin()" 
                                placement="left"
                                :key="`offer-${offer.id}`"
                            />
                            <div class="rotate-270">
                                <span class="badge bg-purple"
                                    >RFQ Item</span
                                >
                            </div>
                            <div class="d-flex align-items-center">
                                <div
                                    style="min-width: 30px;"
                                    class="bg-success bg-gradient text-center me-2 py-1 position-relative"
                                    :isDragPlaceHolder="true"
                                >
                                    <h5
                                        class="
                                            mb-0
                                            position-relative
                                        "
                                    >
                                        {{
                                            offer.offerIndex
                                        }}
                                    </h5>
                                </div>
                                <span class="text-white">{{ offer.itemName }}</span>
                            </div>
                            <div>
                                <small>{{ offer.description }}</small>
                            </div>
                        </td>
                        <td>{{ offer.unit.shortName }}</td>
                        <td>{{ offer.quantity }}</td>
                        <td>{{ formatCurrency(offer.unitCost) }}</td>
                        <td>{{ formatCurrency(offer.total) }}
                            <div class="form-check form-checkbox-outline form-check-success mb-0 mt-2">
                                <input
                                    autocomplete="off"
                                    class="form-check-input"
                                    type="checkbox"
                                    :id="`no-offer-${offer.offer.id}`"
                                    v-model="offer.offer.noOffer"
                                    @click="noSupplierOffer(offer.offer)"
                                />&nbsp;&nbsp;
                                <label 
                                    class="form-check-label"
                                    :for="`no-offer-${offer.offer.id}`"
                                >
                                    No offer
                                </label>
                            </div>
                        </td>
                    </tr>
                    <tr
                        :key="`offer${offer.id}`"
                        class="custom-border-2"
                        :class="{ 'border-success': offer.offer.isWinner }"
                        v-if="!offer.offer.noOffer"
                    >
                        <td class="position-relative">
                            <div class="rotate-270">
                                <span class="badge bg-secondary"
                                    >Item Offer</span
                                >
                            </div>
                            <div>
                                <input
                                    type="text"
                                    placeholder="Item Name"
                                    class="w-100 form-control mb-1 text-warning"
                                    v-model="offer.offer.itemName"
                                    :class="{'is-invalid': submitted && offer.errorItemName}"
                                />
                                <textarea
                                    type="text"
                                    placeholder="Item Description"
                                    class="w-100 form-control short text-warning resize-none mb-1"
                                    @input="autoGrow($event, 15)"
                                    rows="1"
                                    v-model="offer.offer.description"
                                    :ref="`itemDescription${offer.offer.rfqItemId}`"
                                    :class="{'is-invalid': submitted && offer.errorDescription}"
                                ></textarea>
                                <div class="d-flex mt-2 align-items-center justify-content-between">
                                    <div>
                                        <masked-input
                                            v-model="offer.offer.deliveryPeriod"
                                            class="
                                                text-warning
                                                font-weight-bold
                                                span-form-control
                                            "
                                            role="textbox"
                                            placeholder="Delivery Period in Days"
                                            :ref="`ref-offer-${offer.offer.rfqItemId}`"
                                            :mask="dayMask"
                                            @input="autoWidth($event, offer.offer.rfqItemId)"
                                            :class="{'is-invalid': submitted && offer.errorDelivery}"
                                        ></masked-input>
                                        <span v-if="offer.offer.deliveryPeriod"
                                            >calendar day<span
                                                v-if="
                                                    offer.offer.deliveryPeriod >
                                                    1
                                                "
                                                >s</span
                                            ></span
                                        >
                                    </div>
                                </div>
                                <a
                                    href="javascript:void(0);"
                                    :id="`moreSpec${offer.offer.id}`"
                                    ><i
                                        class="
                                            mdi mdi-plus
                                            rotate rotate-90
                                            me-1
                                        "
                                    ></i
                                    >Add More Specifications</a
                                >
                                <b-popover
                                    :target="`moreSpec${offer.offer.id}`"
                                    triggers="click"
                                    placement="right"
                                    :show.sync="offer.offer.showMoreSpec"
                                    custom-class="popover-supplier"
                                >
                                    <template v-slot:title>
                                        <div
                                            class="
                                                d-flex
                                                align-items-center
                                                justify-content-between
                                            "
                                        >
                                            <small
                                                >More Specifications</small
                                            >
                                            <span
                                                class="
                                                    bx bx-x
                                                    font-size-14
                                                    cursor-pointer
                                                "
                                                @click="
                                                    offer.offer.showMoreSpec = false
                                                "
                                            ></span>
                                        </div>
                                    </template>
                                    <div class="row mb-2">
                                        <div class="col-md-6">
                                            <label for="" class="mb-0"
                                                >Brand</label
                                            >
                                            <input
                                                type="text"
                                                placeholder="Enter Brand"
                                                class="
                                                    form-control
                                                    form-control-sm
                                                    text-warning
                                                "
                                                v-model="offer.offer.brand"
                                            />
                                        </div>
                                        <div class="col-md-6">
                                            <label for="" class="mb-0"
                                                >Model</label
                                            >
                                            <input
                                                type="text"
                                                placeholder="Enter Model"
                                                class="
                                                    form-control
                                                    form-control-sm
                                                    text-warning
                                                "
                                                v-model="offer.offer.model"
                                            />
                                        </div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-md-6">
                                            <label for="" class="mb-0"
                                                >Color</label
                                            >
                                            <input
                                                type="text"
                                                placeholder="Enter Color"
                                                class="
                                                    form-control
                                                    form-control-sm
                                                    text-warning
                                                "
                                                v-model="offer.offer.color"
                                            />
                                        </div>
                                        <div class="col-md-6">
                                            <label for="" class="mb-0"
                                                >Condition</label
                                            >
                                            <input
                                                type="text"
                                                placeholder="Enter Condition"
                                                class="
                                                    form-control
                                                    form-control-sm
                                                    text-warning
                                                "
                                                v-model="
                                                    offer.offer.condition
                                                "
                                            />
                                        </div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-md-6">
                                            <label for="" class="mb-0"
                                                >Material Used</label
                                            >
                                            <input
                                                type="text"
                                                placeholder="Enter Material Used"
                                                class="
                                                    form-control
                                                    form-control-sm
                                                    text-warning
                                                "
                                                v-model="
                                                    offer.offer.materialUsed
                                                "
                                            />
                                        </div>
                                        <div class="col-md-6">
                                            <label for="" class="mb-0"
                                                >Package Description</label
                                            >
                                            <input
                                                type="text"
                                                placeholder="Enter Package Description"
                                                class="
                                                    form-control
                                                    form-control-sm
                                                    text-warning
                                                "
                                                v-model="
                                                    offer.offer
                                                        .packageDescription
                                                "
                                            />
                                        </div>
                                    </div>
                                    <div class="mb-2">
                                        <label for="" class="mb-0"
                                            >Dimension Description</label
                                        >
                                        <textarea
                                            rows="2"
                                            placeholder="Enter Dimension Description"
                                            class="
                                                form-control form-control-sm
                                                text-warning
                                            "
                                            v-model="
                                                offer.offer
                                                    .dimensionDescription
                                            "
                                        ></textarea>
                                    </div>
                                    <div class="mb-2">
                                        <label for="" class="mb-0"
                                            >Other Specifications</label
                                        >
                                        <textarea
                                            rows="2"
                                            placeholder="Enter Other Specifications"
                                            class="
                                                form-control form-control-sm
                                                text-warning
                                            "
                                            v-model="
                                                offer.offer.specification
                                            "
                                        ></textarea>
                                    </div>
                                    <div class="mb-2">
                                        <label for="" class="mb-0"
                                            >Notes</label
                                        >
                                        <textarea
                                            type="text"
                                            placeholder="Note Here"
                                            rows="2"
                                            class="
                                                form-control form-control-sm
                                                text-warning
                                            "
                                            v-model="offer.offer.note"
                                        ></textarea>
                                    </div>
                                    <hr />
                                    <div class="d-flex float-end mb-3">
                                        <button
                                            type="button"
                                            class="btn btn-primary me-1"
                                            @click="
                                                offer.offer.showMoreSpec = false
                                            "
                                        >
                                            Save
                                        </button>
                                        <button
                                            type="button"
                                            class="btn btn-link"
                                            @click="
                                                offer.offer.showMoreSpec = false
                                            "
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </b-popover>
                            </div>
                        </td>
                        <td>
                            <multiselect
                                v-model="offer.offer.unit"
                                :options="units"
                                :searchable="true"
                                :close-on-select="true"
                                label="shortName"
                                :show-labels="false"
                                :allow-empty="false"
                                placeholder="Pick a value"
                                input-class="text-warning"
                                class="border-0"
                            ></multiselect>
                        </td>
                        <td>
                            <masked-input
                                type="text"
                                placeholder="Qty"
                                class="w-100 form-control text-warning"
                                :mask="currencyMask"
                                v-model="offer.offer.quantity"
                            ></masked-input>
                        </td>
                        <td>
                            <masked-input
                                placeholder="Unit Cost"
                                class="w-100 form-control text-warning"
                                :mask="currencyMask"
                                v-model="offer.offer.unitCost"
                            ></masked-input>
                        </td>
                        <td>
                            <div class="form-control text-warning">{{ formatCurrency(getTotalByRow(offer.offer)) }}</div>
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
        <div class="text-right mb-3">
            <div class="row">
                <div class="col">
                    <div
                        class="
                            dataTables_paginate
                            paging_simple_numbers
                            float-end
                        "
                    >
                        <ul
                            class="
                                pagination pagination-rounded
                                mb-0
                            "
                        >
                            <!-- pagination -->
                            <b-pagination
                                v-model="currentPage"
                                :total-rows="rows"
                                :per-page="perPage"
                            ></b-pagination>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer d-flex justify-content-between">
            <div>
                <button
                    type="button"
                    class="btn btn-link"
                    @click="addAttachment"
                >
                    <i class="mdi mdi-paperclip"></i> Attachments
                </button>
            </div>
            <div>
                <button
                    type="button"
                    class="btn btn-primary"
                    @click="saveOffers"
                >
                    Save &amp; Apply Changes
                </button>
                <button
                    type="button"
                    class="btn btn-link"
                    @click="$bvModal.hide('offer-modal')"
                >
                    Close
                </button>
            </div>
        </div>
    </b-modal>
</template>